import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
var PADDING = {
  1: {
    top: 'pt-1',
    bottom: 'pb-1'
  },
  2: {
    top: 'pt-2',
    bottom: 'pb-2'
  },
  3: {
    top: 'pt-3',
    bottom: 'pb-3'
  },
  4: {
    top: 'pt-4',
    bottom: 'pb-4'
  },
  5: {
    top: 'pt-5',
    bottom: 'pb-5'
  }
};
export default {
  name: 'FieldSection',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    title: function title() {
      return this.payload.primary.title[0] || {};
    },
    titleColor: function titleColor() {
      return this.payload.primary.title_color;
    },
    subtitle: function subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },
    subtitleColor: function subtitleColor() {
      return this.payload.primary.subtitle_color;
    },
    paragraph: function paragraph() {
      return this.payload.primary.paragraph;
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes';
    },
    paddingTop: function paddingTop() {
      return this.payload.primary.padding_top;
    },
    paddingBottom: function paddingBottom() {
      return this.payload.primary.padding_bottom;
    }
  },
  methods: {
    buildPadding: function buildPadding(arg) {
      return PADDING[arg] || '';
    }
  }
};